module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Heavy-3a12a38ac051b6c298dacc452684d998.eot";